/**
 * Reduce el HTML del editor de noticias a texto plano para excerpts.
 *
 * Usa el DOMParser del navegador (sin dependencias): el documento parseado
 * nunca se inserta al DOM vivo, así que nada se ejecuta. Antes de parsear se
 * inyecta un espacio tras cada cierre de bloque y cada <br> para que
 * `textContent` no pegue "TítuloCuerpo"; al final todo espacio se colapsa.
 * El texto sin HTML (noticias viejas) pasa intacto.
 */
export default function stripHtml(html: string): string {
  const spaced = html.replace(/<(\/(?:p|h[1-6]|li|ul|ol|div|blockquote)|br)\b[^>]*>/gi, '$& ');
  const doc = new DOMParser().parseFromString(spaced, 'text/html');
  return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim();
}
